module.exports = __webpack_public_path__ + "static/media/home7.40f19344.jpg";